<div
  class="container f-body-m f-medium"
  [class.delay]="delay()"
  [class.visible]="visible()"
  [class.inverse]="isInverse()"
>
  <div class="content" [class.onyx-on-inverse]="isInverse()">
    <onyx-spinner [size]="16"></onyx-spinner>

    <ng-content></ng-content>
  </div>
</div>
